import { render } from "./TrainingTargetStore.vue?vue&type=template&id=2168a7dd&scoped=true&ts=true"
import script from "./TrainingTargetStore.vue?vue&type=script&lang=ts"
export * from "./TrainingTargetStore.vue?vue&type=script&lang=ts"

import "./TrainingTargetStore.vue?vue&type=style&index=0&id=2168a7dd&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2168a7dd"]])

export default __exports__